'use strict';
module.exports = [
  '$scope',
  '$uibModalInstance',
  '$q',
  'params',
  'toastService',
  'errorHandlerService',
  'situationRecordService',
  'situationRecordClass',
  'translateFilter',
  'utilsService',
  function (
    $scope,
    $uibModalInstance,
    $q,
    params,
    toastService,
    errorHandlerService,
    situationRecordService,
    situationRecordClass,
    translateFilter,
    utilsService
  ) {
    var modalResult = utilsService.modalResults.cancel;

    $scope.situationRecord = params.situationRecord;

    /**
     * Nuovi validity periods.
     * Li gestisco a parte altrimenti il filtro orderBy ti sposta le righe mentre stai inserendo se inserisci un validity period antecedente a uno già esistente
     */
    $scope.newValidityPeriods = [];

    /**
     * Copia dei periodi di valoidità originari
     */
    var existingValidityPeriods = [];

    /**
     * Aggiunge un validity period
     * @return {undefined}
     */
    $scope.addNewValidityPeriod = function () {
      var d = new Date();

      var newPeriod = {
        dateStart: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0),
        dateEnd: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 0, 0),
      };

      $scope.newValidityPeriods.push(newPeriod);
    };

    /**
     * Cancella un nuovo validity period
     * @param {type} period
     * @return {undefined}
     */
    $scope.delNewValidityPeriod = function (period) {
      if (!$scope.newValidityPeriods) $scope.newValidityPeriods = [];
      var index = $scope.newValidityPeriods.indexOf(period);
      if (index > -1) {
        $scope.newValidityPeriods.splice(index, 1);
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': period'
        );
      }
    };

    /**
     * Cancella un Validity period esistente sul situation record
     * @param {type} period
     * @return {undefined}
     */
    $scope.delValidityPeriod = function (period) {
      if (!$scope.situationRecord.validityPeriods) $scope.situationRecord.validityPeriods = [];
      var index = $scope.situationRecord.validityPeriods.indexOf(period);
      if (index > -1) {
        $scope.situationRecord.validityPeriods.splice(index, 1);
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': period'
        );
      }
    };

    /**
     * Annulla operazione
     * @return {undefined}
     */
    $scope.cancel = function () {
      restoreValidityPeriods();
      $uibModalInstance.dismiss(modalResult);
    };

    //**********************************************************************************
    //******************************* SALVATAGGIO **************************************
    //**********************************************************************************

    /**
     * Salva
     * @return {undefined}
     */
    $scope.save = function () {
      $scope.validationErrors = [];

      //aggiungo i nuovi validity periods

      if ($scope.newValidityPeriods) {
        if (!$scope.situationRecord.validityPeriods) {
          $scope.situationRecord.validityPeriods = [];
        }

        console.log($scope.newValidityPeriods);

        angular.forEach($scope.newValidityPeriods, function (vp) {
          $scope.situationRecord.validityPeriods.push(vp);
        });

        console.log($scope.situationRecord.validityPeriods);
      }
      //formatto le date
      situationRecordClass.formatCurSituationRecordDates($scope.situationRecord);

      //var deferred = $q.defer();

      situationRecordService.update(
        $scope.situationRecord,
        function (res) {
          //                                var ret = res;
          //                                delete ret.$promise;
          //                                delete ret.$resolved;
          //
          //                                $scope.situationRecord = ret;

          var msg = translateFilter('AstralSituationRecord.saveSuccess');
          toastService.createSuccessToast(msg);

          //deferred.resolve(msg);

          modalResult = utilsService.modalResults.saveSuccess;

          $uibModalInstance.close(modalResult);
        },
        function (error) {
          errorHandler(error);
          //ripristino la situazione originaria
          restoreValidityPeriods();
          //                        $scope.situationRecord.validityPeriods = null;
          //                        if (existingValidityPeriods) {
          //                            $scope.situationRecord.validityPeriods = [];
          //                            angular.forEach(existingValidityPeriods, function (vp) {
          //                                $scope.situationRecord.validityPeriods.push(vp);
          //                            });
          //                        }

          modalResult = utilsService.modalResults.saveError;

          //deferred.reject(error);
        }
      );
      //return deferred.promise;
    };

    function restoreValidityPeriods() {
      //ripristino la situazione originaria
      $scope.situationRecord.validityPeriods = null;
      if (existingValidityPeriods) {
        $scope.situationRecord.validityPeriods = [];
        angular.forEach(existingValidityPeriods, function (vp) {
          $scope.situationRecord.validityPeriods.push(vp);
        });
      }
    }

    //**********************************************************************************

    //**********************************************************************************
    //******************************* GESTIONE ERRORE **********************************
    //**********************************************************************************

    /**
     * Array Errori di Validazione
     */
    $scope.validationErrors = [];

    /**
     * Management errori di validaziione riscontrati al salvataggio
     * @return {undefined}
     */
    function errorHandler(error, successMessage, errorMessage) {
      $scope.validationErrors = undefined;
      errorHandlerService
        .handle(error, successMessage, errorMessage)
        .then(function (validationErrors) {
          $scope.validationErrors = validationErrors;
          if ($scope.validationErrors) {
            toastService.createErrorToast(
              translateFilter('AstralSituationRecord.validationErrors')
            );
          }
        });
      if (error && error.status && error.status === errorHandlerService.status500) {
        doBack();
      }
    }

    /**
     * Parsa i valori in $scope.validationErrors per i campi di tipo lista
     * @param {type} listName
     * @param {type} index
     * @param {type} property
     * @return {undefined}P
     */
    $scope.getValidationErrorPopoverMessage = function (listName, index, propertyName) {
      var fieldName = errorHandlerService.getValidationErrorFieldName(
        listName,
        index,
        propertyName
      );

      return $scope.validationErrors[fieldName];
    };

    $scope.getValidationErrorPopoverIsOpenValidityPeriods = function () {
      var fieldName = 'validityPeriods';
      var ret = $scope.validationErrors.hasOwnProperty(fieldName);
      if (!ret) {
        var i = 1;

        angular.forEach($scope.situationRecord.validityPeriods, function (vp) {
          if (!ret) {
            fieldName = errorHandlerService.getValidationErrorFieldName(
              'validityPeriods',
              i,
              'dateStart'
            );
            ret = $scope.validationErrors.hasOwnProperty(fieldName);
          }
          if (!ret) {
            fieldName = errorHandlerService.getValidationErrorFieldName(
              'validityPeriods',
              i,
              'dateEnd'
            );
            ret = $scope.validationErrors.hasOwnProperty(fieldName);
          }
          i = i + 1;
        });
      }
      return ret;
    };

    $scope.getValidationErrorPopoverMessageValidityPeriods = function () {
      var msg = $scope.getValidationErrorPopoverMessage('validityPeriods');
      if (!msg) {
        var i = 1;
        angular.forEach($scope.situationRecord.validityPeriods, function (vp) {
          if (!msg) {
            msg = $scope.getValidationErrorPopoverMessage('validityPeriods', i, 'dateStart');
          }
          if (!msg) {
            msg = $scope.getValidationErrorPopoverMessage('validityPeriods', i, 'dateEnd');
          }
          i = i + 1;
        });
      }
      return msg;
    };

    //**********************************************************************************

    (function init() {
      if ($scope.situationRecord.validityPeriods) {
        existingValidityPeriods = [];
        angular.forEach($scope.situationRecord.validityPeriods, function (vp) {
          existingValidityPeriods.push(vp);
        });
      }
    })();
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/modal/modalValidityPeriodsCtrl.js
// module id = 245
// module chunks = 0